
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/marketplace/market",
      function () {
        return require("private-next-pages/marketplace/market.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/marketplace/market"])
      });
    }
  